import React, { useCallback, InputHTMLAttributes } from "react";

interface RadioButttonProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "size"> {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  size?: number;
  strokeColor?: string;
  fillColor?: string;
  uncheckedColor?: string;
  className?: string;
}
export const RadioButtton: React.FC<RadioButttonProps> = ({
  checked = false,
  onChange,
  disabled = false,
  size = 24,
  strokeColor = "#262429",
  fillColor = "#262429",
  uncheckedColor = "#C0BBC7",
  className = "",
  ...props
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!disabled && onChange) {
        onChange(e.target.checked);
      }
    },
    [disabled, onChange]
  );

  return (
    <label
      style={{
        display: "inline-block",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      className={className}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        style={{ display: "none" }}
        {...props}
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        {checked ? (
          <>
            <circle
              cx="12"
              cy="12"
              r="11"
              stroke={disabled ? "#CCCCCC" : strokeColor}
              strokeWidth="2"
            />
            <circle
              cx="12"
              cy="12"
              r="6"
              fill={disabled ? "#CCCCCC" : fillColor}
            />
          </>
        ) : (
          <circle
            cx="12"
            cy="12"
            r="12"
            fill={disabled ? "#EEEEEE" : uncheckedColor}
          />
        )}
      </svg>
    </label>
  );
};

export default RadioButtton;
